import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress expected auth (401/403) axios rejections during logout/login transitions
// so they don't surface as a blocking CRA runtime-error overlay.
window.addEventListener("unhandledrejection", (e) => {
  const s = e?.reason?.response?.status;
  if (s === 401 || s === 403) e.preventDefault();
});

// Benign "ResizeObserver loop" warnings are promoted by CRA into a full-screen error overlay.
// Swallow them so they don't block the UI (e.g. large dropdowns inside dialogs).
const _roMsg = "ResizeObserver loop";
window.addEventListener("error", (e) => {
  if (typeof e?.message === "string" && e.message.includes(_roMsg)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
